module.exports = __webpack_public_path__ + "img/devices.bd48b132.png";